var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 487,
    height: 207,
    viewBox: "0 0 487 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08,
    clipPath: "url(#clip0_810_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.326 165.139H134.114V204.07H80.2586V165.139H0V125.372L83.821 2.93018H134.114V124.535H156.326V165.139ZM80.2586 124.535V101.093C80.2586 96.6976 80.4682 90.8371 80.6777 83.3023C81.0968 75.7674 81.3064 71.9999 81.5159 71.5813H80.0491C76.9058 78.6976 73.3434 85.186 69.3619 91.4651L47.1493 124.535H80.2586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.006 103.814C316.006 139.395 309.929 165.558 298.194 182.093C286.249 198.628 268.018 207 243.291 207C219.192 207 201.171 198.419 188.807 181.047C176.653 163.674 170.576 137.93 170.576 103.814C170.576 68.0233 176.444 41.8605 188.598 25.1163C200.542 8.37209 218.773 0 243.5 0C267.389 0 285.621 8.7907 297.775 26.1628C309.929 43.5349 316.006 69.2791 316.006 103.814ZM224.641 103.814C224.641 126.628 226.108 142.326 228.832 150.698C231.765 159.279 236.376 163.465 243.081 163.465C249.787 163.465 254.607 159.07 257.54 150.279C260.265 141.488 261.732 126 261.732 103.814C261.732 81.4186 260.265 65.9302 257.54 56.9302C254.607 47.9302 249.997 43.5349 243.291 43.5349C236.585 43.5349 231.766 47.9302 229.041 56.5116C226.108 65.093 224.641 80.7907 224.641 103.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 165.139H464.787V204.07H410.932V165.139H330.674V125.372L414.495 2.93018H464.787V124.535H487V165.139ZM411.142 124.535V101.093C411.142 96.6976 411.352 90.8371 411.561 83.3023C411.98 75.7674 412.19 71.9999 412.399 71.5813H410.932C407.789 78.6976 404.227 85.186 400.245 91.4651L377.823 124.744H411.142V124.535Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9424 179.427C55.9424 179.427 162.883 184.362 264.888 184.362C366.893 184.362 431.057 179.427 431.057 179.427",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.726 105.391V126.779C251.726 135.005 246.79 139.941 246.79 139.941H241.854L230.338 153.103L225.402 172.845H222.111V179.426H204.014L205.001 177.452C206.482 174.655 209.278 172.845 212.569 172.845H215.53L227.047 138.295V110.326",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.145 139.94L266.533 169.555L264.394 171.2L266.533 174.49V179.426H250.081V179.262C251.068 175.478 254.358 172.845 258.307 172.845V171.2L236.919 146.521",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.048 125.134H251.726",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.24 105.391L220.466 121.843H222.112V106.542C222.112 96.9999 228.364 79.0668 228.364 79.0668V70.8406",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.79 105.391H131.623",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M279.695 77.4216H284.631",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M279.695 82.3572H284.631",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M279.695 87.293H284.631",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M251.726 77.4216H276.404V87.2931H270.975C262.749 87.2931 254.852 84.6607 248.106 79.8895L246.79 79.0669",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M251.726 67.5503C251.726 67.5503 251.726 75.7765 251.726 77.4217L250.574 77.7508C244.816 79.7251 238.564 80.2186 232.641 79.5605L228.692 79.067",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M217.999 54.0593C217.505 57.0208 218.986 59.8177 221.947 61.1339C224.744 62.2855 227.87 61.4629 229.68 59.1596",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M259.788 52.4139C259.788 52.4139 254.194 44.6813 243.665 40.0746C233.135 35.468 223.593 36.7842 223.593 36.7842C227.87 26.7482 244.816 20.8253 250.904 23.4577C257.485 26.4191 264.066 42.378 259.788 52.4139Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M229.68 30.5322C229.022 30.5322 228.364 30.5322 227.87 30.5322",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M259.952 43.5296C257.32 40.8972 252.713 36.7841 246.132 33.9872C239.551 31.1903 233.464 30.5322 229.68 30.5322",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M261.104 44.8457C260.775 44.5167 260.446 44.0231 259.952 43.5295",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M273.608 66.3984C271.14 67.3855 268.179 66.2339 267.192 63.6015L266.534 62.1208C264.066 63.1079 261.104 61.9562 260.117 59.3239L259.459 57.8431V51.0977",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M251.89 45.5039L251.068 47.3137C250.08 49.617 251.068 52.2494 253.371 53.2365L253.7 53.4011L253.042 54.8818C251.89 57.3496 253.042 60.3111 255.674 61.2982C251.397 71.3342 239.715 75.9409 229.679 71.6632C219.643 67.3856 215.037 55.7044 219.314 45.6684",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M255.181 62.2856C253.701 65.5761 255.346 69.5247 258.636 71.0054",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M276.24 47.1494L275.582 48.6301C274.431 51.098 271.634 52.2497 269.166 51.2625C268.014 53.7304 265.217 54.882 262.749 53.8949L261.269 53.2368",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M222.111 97.1646H251.726",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M246.79 105.391H361.957",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M208.95 108.681V105.391L200.723 102.1L199.078 103.745V108.681L200.723 110.326H208.95L212.24 107.036",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M253.371 110.326L251.726 105.391L259.952 102.1L261.597 103.745V108.681L259.952 110.326H253.371Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M223.757 36.2905C222.935 39.7455 219.151 41.7198 215.86 40.4036L213.886 39.581",
    stroke: "white",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_810_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 487,
    height: 207,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.6fa69efbb334be7a3269e80c2dcb1793.svg";
export { ForwardRef as ReactComponent };